var _DomainActionsErrorsM, _DomainActionsErrorsM2, _DomainActionsErrorsM3;
import { DomainProductTypeEnum } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { Box } from '@wix/design-system';
import { DomainActionsErrorsMap, DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { GeneralAnonymousOverride, SubdomainRootTaken } from '../../../Components';
import { Base44MoreTools } from '../../../Components/Base44MoreTools';
import { Base44PreSuggestions } from '../../../Components/Base44PreSuggestions';
import { Base44SocialProofCard } from '../../../Components/Base44SocialProofCard';
import { FAQs } from '../../../Components/FAQs';
import { Base44GateHeader } from '../../../Components/Headers/Base44GateHeader/Base44GateHeader';
import { TldPromotionsWithPrice } from '../../../Components/TldPromotionsWithPrice';
import { Base44VoucherBanner } from '../../../Components/VoucherBanner/Base44VoucherBanner';
import { useDomainSearchGateBi } from '../../../hooks/useDomainSearchGateBi';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { useQuerySubmit } from '../../../hooks/useQuerySubmit';
import { prefetchRecommendations } from '../../../hooks/useRecommendations';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { ViewMode } from '../../../types';
import { useDeclaredExperiments } from '../../../hooks/declaredExperiments';
const customConfiguration = {
  ...(((_DomainActionsErrorsM = DomainActionsErrorsMap.assign) == null ? void 0 : _DomainActionsErrorsM.reduce((acc, status) => ({
    ...acc,
    [status]: GeneralAnonymousOverride
  }), {})) ?? {}),
  ...(((_DomainActionsErrorsM2 = DomainActionsErrorsMap.connect) == null ? void 0 : _DomainActionsErrorsM2.reduce((acc, status) => ({
    ...acc,
    [status]: GeneralAnonymousOverride
  }), {})) ?? {}),
  ...(((_DomainActionsErrorsM3 = DomainActionsErrorsMap.transfer) == null ? void 0 : _DomainActionsErrorsM3.reduce((acc, status) => ({
    ...acc,
    [status]: GeneralAnonymousOverride
  }), {})) ?? {}),
  transfer: GeneralAnonymousOverride,
  connect: GeneralAnonymousOverride,
  subdomainRootIsNotConnected: SubdomainRootTaken,
  domainTakenInWix: GeneralAnonymousOverride,
  subdomainTakenInWix: SubdomainRootTaken
};
export const EmbeddedHomePage = _ref => {
  let {
    handlers,
    externalViewer,
    onSearchSubmit
  } = _ref;
  return /*#__PURE__*/React.createElement(DomainsApiClient.Provider, {
    overrides: {
      getPurchasePermissions: {
        hasPermission: true
      }
    }
  }, /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    actions: {
      siteInfo: {
        externalViewer: Boolean(externalViewer)
      },
      handlers
    },
    statusesCustomComponents: {
      customConfiguration
    }
  }, /*#__PURE__*/React.createElement(EmbeddedHomePageContent, {
    onSearchSubmit: onSearchSubmit
  })));
};
const EmbeddedHomePageContent = _ref2 => {
  let {
    onSearchSubmit
  } = _ref2;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const isMobile = useIsMobile();
  const experimentIds = useDeclaredExperiments();
  const history = useHistory();
  const {
    getUrlState
  } = DomainSearchSuiteModule.SDK.hooks.useUrlRecovery();
  useDomainSearchGateBi({
    viewMode: ViewMode.BASE44,
    pageType: 'landing'
  });
  useQuerySubmit({
    path: '/results'
  });
  const {
    data: domainsAccount
  } = DomainsApiClient.hooks.useDomainsAccount({}, true, {
    refetchOnMount: true,
    staleTime: 1000 * 60 * 3
  });
  // TODO: translation or assert and trust error boundary
  const {
    siteName
  } = getPremiumEssentialsSafe() ?? {
    siteName: 'your app'
  };
  const searchBar = /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.DomainSearchBar, {
    showOptionsIfEmptyInput: false,
    hideUnassignedDomains: true,
    autoFocus: !isMobile,
    useModalToolbar: isMobile,
    Layouts: {
      ToolBarContainer: () => /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    placeholder: isMobile ? t('domains_search_gate.base44.gate.mobile.searchbar.placeholder') : t('domains_search_gate.base44.gate.searchbar.placeholder'),
    onSubmit: filters => {
      prefetchRecommendations({
        experimentIds,
        productType: DomainProductTypeEnum.BASE44,
        hasValidVouchers: domainsAccount == null ? void 0 : domainsAccount.hasValidVouchers
      });
      onSearchSubmit == null || onSearchSubmit(filters);
      const searchParams = getUrlState(filters);
      history.push(`/results?${searchParams}`);
    },
    onFiltersChange: (key, value) => {
      if (key === 'tlds') {
        DomainSearchSuiteModule.internals.bi.onSelectTld == null || DomainSearchSuiteModule.internals.bi.onSelectTld({
          tld: JSON.stringify(value)
        });
      } else {
        DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
          ctaClick: key,
          value: JSON.stringify(value)
        });
      }
    }
  });
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    direction: "vertical",
    gap: "SP4",
    padding: isMobile ? '16px SP4' : '16px SP6',
    backgroundColor: "white"
  }, /*#__PURE__*/React.createElement(Base44VoucherBanner, null), /*#__PURE__*/React.createElement(Box, {
    align: "center",
    borderRadius: "12px",
    width: "100%",
    direction: "vertical",
    gap: "32px",
    boxSizing: "border-box",
    padding: isMobile ? '24px 16px 32px' : '48px 32px 62px',
    background: "linear-gradient(180deg, #F6F6F6 -11.12%, #D8E0E0 61.18%, rgba(252, 152, 70, 0.70) 94.96%, #FC7346 100%)",
    overflow: "hidden",
    zIndex: 1
  }, /*#__PURE__*/React.createElement(Base44GateHeader, null), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%'
    }
  }, searchBar)), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: isMobile ? '36px' : 'SP4',
    width: "100%",
    display: "grid",
    gridTemplateRows: "repeat(max-content, auto)"
  }, /*#__PURE__*/React.createElement(Base44PreSuggestions, {
    query: siteName
  }), /*#__PURE__*/React.createElement(Base44SocialProofCard, null), /*#__PURE__*/React.createElement(TldPromotionsWithPrice, {
    variant: "base44"
  }), /*#__PURE__*/React.createElement(Base44MoreTools, null), /*#__PURE__*/React.createElement(FAQs, {
    variant: "base44",
    onToggle: index => {
      DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
        ctaClick: 'asked_questions',
        value: JSON.stringify(index)
      });
    }
  })));
};
//# sourceMappingURL=EmbeddedHomePage.js.map